import React from 'react';
import { Star } from 'lucide-react';

const Reviews = ({ limit = null, showTrustpilot = true }) => {
  const reviews = [
    {
      name: "James Mitchell",
      location: "Leicester",
      image: "/reviews/image_0002.jpg",
      rating: 5,
      date: "2 weeks ago",
      review: "Absolutely brilliant service! Had a nasty scratch on my BMW that I thought would cost a fortune to fix. GBW Bodyworks did an incredible job - you honestly can't tell where the damage was. The color match is perfect and the price was very reasonable. Highly recommend!"
    },
    {
      name: "Sarah Thompson",
      location: "Countesthorpe",
      image: "/reviews/image_0003.png",
      rating: 5,
      date: "3 weeks ago",
      review: "Took my car here after a minor parking incident left a dent in the door. The team were professional, friendly, and kept me updated throughout. The repair is flawless - looks like it never happened. Will definitely use them again if needed."
    },
    {
      name: "David Clarke",
      location: "Wigston",
      image: "/reviews/image_0004.jpg",
      rating: 5,
      date: "1 month ago",
      review: "Fantastic work on my alloy wheels. They looked terrible after years of kerb damage, but GBW has brought them back to life. The refurbishment is outstanding and they look brand new. Great value for money too."
    },
    {
      name: "Emma Roberts",
      location: "Oadby",
      image: "/reviews/image_0005.jpg",
      rating: 4,
      date: "1 month ago",
      review: "Very pleased with the bumper repair on my Audi. The work was completed on time and to a high standard. Only reason for 4 stars is it took a day longer than initially quoted, but the quality made up for it. Would use again."
    },
    {
      name: "Michael Patterson",
      location: "Leicester",
      image: "/reviews/image_0006.png",
      rating: 5,
      date: "1 month ago",
      review: "Had stone chip repairs done on the bonnet of my Mercedes. The attention to detail is exceptional - each chip was carefully filled and matched perfectly. You'd never know they were there. Professional service from start to finish."
    },
    {
      name: "Rachel Green",
      location: "Blaby",
      image: "/reviews/image_0007.png",
      rating: 5,
      date: "2 months ago",
      review: "Can't fault the service. My car had quite a few scratches from someone keying it, and I was devastated. GBW made it look perfect again. The team were sympathetic and did an amazing job. Thank you so much!"
    },
    {
      name: "Peter Williams",
      location: "Narborough",
      image: "/reviews/image_0008.jpg",
      rating: 5,
      date: "2 months ago",
      review: "Top quality paint work! Had a full respray on one panel and it's indistinguishable from the rest of the car. The color match is spot on. Fair pricing and excellent workmanship. Highly recommended."
    },
    {
      name: "Lisa Anderson",
      location: "Leicester",
      image: "/reviews/image_0009.jpg",
      rating: 4,
      date: "2 months ago",
      review: "Good service overall. The dent removal was done well and the car looks great. Communication could have been slightly better, but the end result speaks for itself. Happy with the work."
    },
    {
      name: "Thomas Baker",
      location: "Countesthorpe",
      image: "/reviews/image_0010.png",
      rating: 5,
      date: "3 months ago",
      review: "Excellent work on my Range Rover. Had several panels repaired and painted, and the finish is absolutely flawless. The attention to detail is impressive. Well worth the money. Will be back for any future work needed."
    },
    {
      name: "Jennifer Moore",
      location: "Wigston",
      image: "/reviews/image_0011.jpg",
      rating: 5,
      date: "3 months ago",
      review: "Brilliant service from start to finish. The quote was fair, the work was done quickly, and the quality is outstanding. My car looks brand new again. Thank you to the whole team!"
    },
    {
      name: "Robert Taylor",
      location: "Oadby",
      image: "/reviews/image_0013.png",
      rating: 5,
      date: "3 months ago",
      review: "Professional and reliable. Had ceramic coating applied to my new car and it looks stunning. The paintwork has an incredible depth and shine. Great investment for protecting the vehicle."
    },
    {
      name: "Amanda Hughes",
      location: "Leicester",
      image: "/reviews/image_0014.jpg",
      rating: 5,
      date: "4 months ago",
      review: "Couldn't be happier with the repair work. My car was badly scratched and I thought it was ruined, but GBW worked miracles. The repair is invisible and the car looks perfect. Absolutely fantastic!"
    }
  ];

  const displayedReviews = limit ? reviews.slice(0, limit) : reviews;
  const averageRating = (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <div>
      {showTrustpilot && (
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 bg-white px-8 py-4 rounded-lg shadow-md">
            <img 
              src="/Trustpilot_Logo_(2022).svg.png" 
              alt="Trustpilot" 
              className="h-6"
            />
            <div className="border-l border-gray-300 pl-3">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star 
                    key={i} 
                    className={`w-5 h-5 ${i < Math.floor(averageRating) ? 'fill-green-500 text-green-500' : 'text-gray-300'}`}
                  />
                ))}
              </div>
              <p className="text-sm text-gray-600 mt-1">
                <span className="font-bold text-dark-navy">{averageRating}</span> out of 5 based on <span className="font-bold">{reviews.length} reviews</span>
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {displayedReviews.map((review, index) => (
          <div 
            key={index} 
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow duration-300"
          >
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={review.image} 
                alt={review.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h4 className="font-bold text-dark-navy">{review.name}</h4>
                <p className="text-sm text-gray-500">{review.location}</p>
              </div>
            </div>

            <div className="flex items-center gap-2 mb-3">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star 
                    key={i} 
                    className={`w-4 h-4 ${i < review.rating ? 'fill-green-500 text-green-500' : 'text-gray-300'}`}
                  />
                ))}
              </div>
              <span className="text-sm text-gray-500">{review.date}</span>
            </div>

            <p className="text-gray-700 leading-relaxed text-sm">
              {review.review}
            </p>

            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center gap-2">
              <img 
                src="/Trustpilot_Logo_(2022).svg.png" 
                alt="Trustpilot" 
                className="h-4 opacity-60"
              />
              <span className="text-xs text-gray-500">Verified Review</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
